import React, { useState } from 'react';

import { Button, Group, Stack } from '@mantine/core';

import MyMailings from '../../../blocks/MyMailings';
import Fetcher from '../../../common/communicate';
import Pocket from '../../../components/DataTable/PocketDataTable';
import getRandomEmoji from '../../../tools/getRandomEmoji';

const opts = {
    mailing_list_vkplay: {
        api: 'pockets/mailing_list_vkplay/?',
        restTest: 'mail_vkplay/send_test',
        restProd: 'mail_vkplay/send_prod',
        project: 'media.vkplay.ru',
    },
};

const dateOptions = {
    day: 'numeric', month: 'long', hour: 'numeric', minute: 'numeric', second: 'numeric',
};

export default function MailingList({ type }) {
    const [newMailing, setNewMailing] = useState(0);
    const [isSendDisabled, setSendDisabled] = useState(true);

    function sendTestSegment() {
        Fetcher(opts[type].restTest, 'POST', () => {
            setSendDisabled(false);
            setNewMailing({
                emoji: getRandomEmoji(),
                type: 'test',
                time: new Date().toLocaleDateString('ru', dateOptions),
            });
        });
    }

    function sendMainSegment() {
        Fetcher(opts[type].restProd, 'POST', () => {
            setSendDisabled(true);
            setNewMailing({
                emoji: getRandomEmoji(),
                type: 'prod',
                time: new Date().toLocaleDateString('ru', dateOptions),
            });
        });
    }

    return (
        <>
            <Pocket
                type={type}
                project={opts[type].project}
                columnsArray={[
                    { type: 'type' },
                    {
                        type: 'title',
                        accessor: 'entity.title',
                    },
                    { type: 'edit' },
                    { type: 'delete' },
                ]}
                requiredFields={[]}
                formFields={[
                    {
                        type: 'storySearch',
                        name: 'storySearch',
                    },
                ]}
                renderRightColumn={() => (
                    <Stack mt="md">
                        <MyMailings newMailing={newMailing} project={opts[type].project.split('.')[0]} />
                    </Stack>
                )}
            />
            <Group mt="md" ml="sm">
                <Button
                    color="green"
                    variant="outline"
                    onClick={sendTestSegment}
                >
                    Тестовая рассылка
                </Button>
                <Button
                    disabled={isSendDisabled}
                    color="green"
                    onClick={sendMainSegment}
                >
                    Основная рассылка
                </Button>
            </Group>
        </>
    );
}
